export default {
  getCurrentProtocol: state => {
    return state.protocol
  },
  hasRole: state => role => {
    if (state.profile.type !== undefined) {
      return state.profile.type.indexOf(role) > -1
    } else {
      return false
    }
  },
  getProfile: state => state.profile,
  isAuthenticated: state => !!state.token
}



// WEBPACK FOOTER //
// ./src/store/getters.js